module.exports = __webpack_public_path__ + "img/a-ziyuan13.7c85b23c.png";